import { useEffect } from 'react'

import { fetchFlightCampaign } from 'actions/FlightActions'
import { useAppSelector, useAppDispatch } from 'hooks/reduxHooks'

type Result = [
  campaign: App.FlightCampaign | undefined,
  loading: boolean,
  error?: string
]

export function useFlightCampaign(id: string): Result {
  const dispatch = useAppDispatch()

  useEffect(() => {
    dispatch(fetchFlightCampaign(id))
  }, [id, dispatch])

  const campaign = useAppSelector(state => state.flights.campaign[id])

  return [campaign?.data, !!campaign?.fetching, campaign?.error]
}
